export function getUser (state) {
  return state.user
}



// WEBPACK FOOTER //
// ./src/vuex/auth/getters.js